import { connect } from 'react-redux';

import { getUserContext } from 'selectors/user/userSelectors';
import { getWeddingPageByTypeV2 } from '../../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../../actions/website/EntityActions';
import Events from './Events';

const mapStateToProps = (state, ownProps) => ({
  events: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  busy: state.publicWebsite.busy,
  wedding: state.publicWebsite.wedding,
  slug: state.publicWebsite.wedding.slug,
  userContext: getUserContext(state),
});

const mapDispatchToProps = dispatch => ({
  getEventEntities: () => dispatch(getWeddingPageByTypeV2('event')),
  unloadEntities: () => dispatch(resetEntities()),
});

const EventContainer = connect(mapStateToProps, mapDispatchToProps)(Events);

export default EventContainer;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Events/index.js